import React from 'react';
import API from '../../configAPI';
import APP_CONFIG from '../../config';
import BarLoader from 'react-spinners/BarLoader';
class FormContact extends React.Component{
    constructor(props){
        super(props);
        this.state={
            full_name:'',
            company:'',
            jobtitle:'',
            email:'',
            phone_number:'',
            message:'Deseo promocionar mis productos',
            loading:false,
            message_serve:''
        }
    }
    handleChange=(e)=>{
        this.setState({
            [e.target.name] : e.target.value
        });
    
    }
    handleSubmit=(e)=>{
        this.setState({loading:true});
        e.preventDefault();
        API.PRODUCTS.post('contact-info',{
            full_name:this.state.full_name,
            company:this.state.company,
            jobtitle:this.state.jobtitle,
            phone_number:this.state.phone_number,
            email:this.state.email,
            message:this.state.message
        })
        .then(resp=>{
            this.setState({
                message_serve:resp.data.message,
                loading:false
            })
        })
        .catch(err => {
            this.setState({loading:false});
            console.log(err);
        })
    }
    render(){
        return(
        <div className="text-center">
            <div className="d-flex justify-content-center">
            <BarLoader
                width={100}
                height={4}
                color={APP_CONFIG.spinner_color}
                loading={this.state.loading}
            />
            {this.state.message_serve!==''&&
            <div className="alert alert-success">{this.state.message_serve}</div>
            }
            
            </div>
          <form id="solicitar" onSubmit={this.handleSubmit}>
            <div className="row px-5 mt-5">
              <section className="col-xs-12 col-md-6">
                <div className="form-group">                  
                  <input type="text" onChange={this.handleChange} className="form-control" id="nombre" name="full_name" placeholder="Ingrese su nombre y apellidos" required />                 
                </div>                
              </section>
              <section className="col-xs-12 col-md-6">
                <div className="form-group">                  
                  <input type="text" onChange={this.handleChange} className="form-control" name="company" id="company" placeholder="Empresa (opcional)" />
                </div>                
              </section>
            </div>
            <div className="row px-5 mt-2">
              <section className="col-xs-12 col-md-6">
                <div className="form-group">                  
                  <input type="text" onChange={this.handleChange} className="form-control" id="cargo" name="jobtitle" placeholder="Cargo (Opcional)"/>                 
                </div>
              </section>
              <section className="col-xs-12 col-md-6">
                <div className="form-group">                  
                  <input type="text" onChange={this.handleChange} className="form-control" name="email" id="correo" placeholder="Ingrese su correo electrónico" required />                 
                </div>
              </section>
            </div>
            <div className="row px-5 mt-2 text-left">
              <section className="col-xs-12 col-md-6">
                <div className="form-group">                  
                  <input type="text" onChange={this.handleChange} className="form-control" id="telf" name="phone_number" placeholder="Ingrese su nro de Teléfono/Móvil" required />                 
                </div>
              </section>
              <section className="col-xs-12 col-md-6">
                <div className="form-group">                 
                  <textarea name="message" onChange={this.handleChange} id="mensaje" className="form-control" rows="3" defaultValue={this.state.message}></textarea>
                </div>
              </section>
            </div>  
            <div className="form-group form-check">
              <input type="checkbox" className="form-check-input" id="check" required/>
              <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}> Al marcar ésta casilla acepto la <a type="button" class="btn btn-primary calcular btn-terminos" data-toggle="modal" data-target="#exampleModalpolitica"> Política de protección de datos personales</a> . </label>              
            </div>          
            <div className="form-group form-check">
              <input type="checkbox" className="form-check-input" id="check" />
              <label className="form-check-label text-muted" style={{fontSize: '0.85rem'}}>Autorizo el tratamiento de mis datos personales para recibir ofertas y comunicaciones comerciales por parte de esta empresa.</label>              
            </div>
            <button type="submit" className="btn btn-primary">Enviar</button>
          </form>
        </div>
        )
    }
}
export default FormContact;